import { clientConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

export interface PostCheckMachineAvailabilityResponse {
  machine_id?: string;
  operation_id?: string;
  operation_type?: string;
  message?: string;
  detail?: string;
}

export interface PostCheckMachineAvailabilityPayload {
  gateway_id: string;
  hostname: string;
}

export const postCheckMachineAvailability = async (
  namespace: string,
  payload: PostCheckMachineAvailabilityPayload,
) => {
  const url = clientConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.post<PostCheckMachineAvailabilityResponse>(
      `${url}/api/v4/ns/${namespace}/machines/availability`,
      payload,
      { headers },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw err;
    }

    throw new Error(
      "An unexpected error occurred while checking machine availability.",
    );
  }
};
